import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {Autocomplete, TextField} from "@mui/material";
import type {SimpleSitUserProfile} from "../ApiTypes";
import {useSitStores} from "../../stores";
import {runInAction} from "mobx";

interface Props {
    label: string,
    placeholder: string,
    disabled: boolean,
    value: SimpleSitUserProfile | undefined | null,
    onChange: (event: React.SyntheticEvent, value: SimpleSitUserProfile | null) => void,
    required?: boolean,
}

export const SitUserSelect: React.FC<Props> = observer(({
                                                            label,
                                                            placeholder,
                                                            disabled,
                                                            value,
                                                            onChange,
                                                            required
                                                        }: Props) => {
        const {sitUserStore} = useSitStores();

        useEffect(() => {
            if (sitUserStore.userListRM.result === undefined && !sitUserStore.userListRM.busy)
                sitUserStore.userListFilter.setFilters([['search', '']]);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        // Label-above `.sitf` pattern so it matches the native SitField controls.
        return <label className="sitf">
            <span className="sitf-label">{label}{required && <span className="sitf-req">*</span>}</span>
            <Autocomplete
                disabled={disabled}
                size="small"
                selectOnFocus clearOnBlur handleHomeEndKeys
                options={(sitUserStore.userListRM.result?.results ?? []) as SimpleSitUserProfile[]}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                filterOptions={(options) => options}
                value={value ?? null}
                renderOption={(props, option) =>
                    <li {...props} key={option.id}>
                        {option.name + ' <' + option.email + '>'}
                    </li>}
                onChange={onChange}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        variant="outlined"
                        placeholder={placeholder}
                        inputProps={{...params.inputProps, required: required && !value}}/>}
                onInputChange={(_, value, reason) => {
                    switch (reason) {
                        case 'input':
                            runInAction(() => {
                                sitUserStore.userListFilter.setFilters([['search', value]])
                            });
                            break;
                        case 'clear':
                            runInAction(() => {
                                sitUserStore.userListFilter.setFilters([['search', '']])
                            });
                            break;
                    }
                }}/>
        </label>
    }
)
